import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { OrganizationSimple } from '../OrganizationSimple.js';
export class EmailAddressSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.hardBounce = false;
        this.markedAsSpam = false;
        this.organization = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], EmailAddressSettings.prototype, "email", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailAddressSettings.prototype, "unsubscribedMarketing", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailAddressSettings.prototype, "unsubscribedAll", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 385 })
], EmailAddressSettings.prototype, "hardBounce", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 385 })
], EmailAddressSettings.prototype, "markedAsSpam", void 0);
__decorate([
    field({ decoder: OrganizationSimple, nullable: true })
], EmailAddressSettings.prototype, "organization", void 0);
//# sourceMappingURL=EmailAddressSettings.js.map